'use client';

import { Button } from "@/components/ui/button";

interface RetryButtonProps {
  message: string;
}

export function RetryButton({ message }: RetryButtonProps) {
  return (
    <div className="text-center py-8">
      <p className="text-red-500">{message}</p>
      <Button 
        onClick={() => window.location.reload()} 
        className="mt-4"
        variant="destructive" // Use a more appropriate variant if desired
      >
        다시 시도
      </Button>
    </div>
  );
} 